import { IFIReportType, IFIReportTypeItem } from '@cims-online/shared'
import CIMSCollapse from 'components/CIMSCollapse'
import { TypeFormItemsProps, TypeItem } from './types'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { useState } from 'react'
import { LabeledValueType } from 'components/CIMSSelect/types'

const TypeFormItems: React.VFC<TypeFormItemsProps> = ({ onChange, value }) => {
  const [values, setValues] = useState<Map<string, TypeItem>>(
    (value ?? []).reduce(
      (map, v) => map.set(v.classType, v),
      new Map<string, TypeItem>()
    )
  )

  const change = (
    className: IFIReportTypeItem['classType'],
    recipients: LabeledValueType[]
  ) => {
    setValues((prev) => {
      const map = new Map(prev)
      map.set(className, {
        ...IFIReportType.findOrFail(({ classType }) => classType === className),
        recipients,
      })
      onChange?.([...map.values()])
      return map
    })
  }
  return (
    <CIMSCollapse
      panels={IFIReportType.values.map((ifiReport) => {
        return {
          key: ifiReport.classType,
          header: {
            type: 'described',
            name: ifiReport.type,
          },
          children: (
            <CIMSFormItem label="Recipients">
              <RecipientsSelect
                value={values.get(ifiReport.classType)?.recipients ?? []}
                onChange={(recipients) => {
                  change(ifiReport.classType, recipients as LabeledValueType[])
                }}
              />
            </CIMSFormItem>
          ),
        }
      })}
    />
  )
}

export default TypeFormItems
